import { CHANGE_DATE_REQUEST_STATUS } from '../../calendar/constants/ChangeDateRequestConstants';

const EventDateChangeReviewMapper = {
  ToApolloInput: (formData, reviewData) => ({
    Id: reviewData.Id,
    EventId: reviewData.EventId,
    Status: formData.Status,
    DeclineComment:
      formData.Status === CHANGE_DATE_REQUEST_STATUS.DECLINED ? formData.DeclineComment : null
  })
};

export default EventDateChangeReviewMapper;
